import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { jsonToCSS } from '../../../helpers/styles';
import useMapLocation from '../../common-components/hooks/useMapLocation';
import useMouseMove from '../../common-components/hooks/useMouseMove';
import MapSizeContext from '../../common-components/MapSizeContext';
import MonitorContext from '../MonitorContext';
import { dimension } from '../WindowConfig';
import BallTabPosition from './BallTabPosition';
import GeneralInfoArea from './GeneralInfoArea';
import RangeInOutArea from './RangeInOutArea';
import TutorialArea from './TutorialArea';

interface ICommonInformationAreaProps {
  areaRef: any;
}

const Container = styled.div`
  ${jsonToCSS(dimension.generalDisplayArea)}
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 200;
  position: absolute;
  pointer-events: none;
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  pointer-events: auto;
`;

const DummyElement: React.FC<any> = () => {
  return <div></div>;
};

const CommonInformationArea: React.FC<ICommonInformationAreaProps> = (
  props
) => {
  const [latLong, setLatLong] = useState<any>({
    latV: '0',
    latH: '',
    longV: '0',
    longH: '',
  });
  const sizes = useContext(MapSizeContext);
  const { monitor } = useContext<any>(MonitorContext);
  const { xyToLatLang } = useMapLocation(monitor, sizes);
  const mapContainer = useSelector(
    (state: any) => state.executor.monitorMaps[monitor]
  );
  // const generalDisplayAreaRef = useRef(null);
  const disableWhenMapIsNotPerset = { opacity: 1 };
  const { areaRef, ...rest } = props;

  const onMouseMove = (x: any, y: any) => {
    const [latV, latH, longV, longH] = xyToLatLang(x, y);
    // console.log('useMouseMove ', x, y, latV, latH, longV, longH);
    setLatLong({
      latV,
      latH,
      longV,
      longH,
    });
  };
  useMouseMove(areaRef, (x, y) => {
    onMouseMove(x, y);
  }); //Yet to add the logic for calculating lat long values based on x and y positions, for now just added mousemove event and displaying x and y values for ball tab position
  return (
    <Container {...rest}>
      <InformationContainer>
        {mapContainer.map && (
          <>
            <DummyElement style={{ width: '160px' }} />
            {/* <PreliminaryHookArea /> */}
            <GeneralInfoArea />
            <BallTabPosition
              lat={`${latLong.latV} ${latLong.latH}`}
              long={`${latLong.longV} ${latLong.longH}`}
            />
          </>
        )}
      </InformationContainer>
      <InformationContainer style={{ height: '130px' }}>
        {mapContainer.map ? (
          <RangeInOutArea />
        ) : (
          <DummyElement style={{ width: '160px' }} />
        )}
        <TutorialArea />
        {mapContainer.map ? (
          // <BearingRangeArea />
          <DummyElement style={{ width: '243px' }} />
        ) : (
          <DummyElement style={{ width: '243px' }} />
        )}
      </InformationContainer>
    </Container>
  );
};

export default CommonInformationArea;
